exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "/*----------------------------------*\\\n  #SETTINGS\n\\*----------------------------------*/\n/*----------------------------------*\\\n  #MEDIA\n\\*----------------------------------*/\n/*----------------------------------*\\\n  #TYPOGRAPHY\n\\*----------------------------------*/\n/*----------------------------------*\\\n  #COLORS\n\\*----------------------------------*/\n/*----------------------------------*\\\n  #EASES\n\\*----------------------------------*/\n/*----------------------------------*\\\n  #GRID\n\\*----------------------------------*/\n/*----------------------------------*\\\n  #SPACING\n\\*----------------------------------*/\n.page-basket {\n  background-color: #FFBAA2;\n  padding: 20px;\n  height: 100%; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["/home/vsts/work/1/s/F.SurplusPWA/ClientApp/src"],"sourceMap":true}!./src/containers/Basket/Basket.scss
// module id = 218
// module chunks = 0